import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { DispatchBoardPanels } from "../../shared/enums/DispatchBoardPanels";
import { DispatchBoardService } from '../../shared/services/dispatch-board.service';
import { DispatchBoardSearch } from '../../shared/models/DispatchBoardSearch';
import { GlobalsService } from '../../shared/services/globals.service';
import { DragParent } from '../../shared/enums/DragParent';
import { WindowContents } from '../../shared/enums/windowContents';
import { Subscription } from 'rxjs/internal/Subscription';
import { animate, style, transition, trigger } from "@angular/animations";
import { CommonFunctions } from '../../shared/static/common-functions';
import { CommonValues } from "@app/cp/shared/static/CommonValues";
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { PriorityFilterState } from "@app/cp/dispatch-board/dispatch-board-widget/dispatch-board-widget-status/priority/priority.component";

@Component({
    selector: 'cp-dispatch-board-widget-calendar',
    templateUrl: './dispatch-board-widget-calendar.component.html',
    styleUrls: ['./dispatch-board-widget-calendar.component.scss'],
    animations: [
        trigger('fadein', [
            transition(':enter', [
                style({ opacity: 'translateY(-100%)' }),
                animate('200ms ease-in', style({ opacity: 'translateY(0%)' }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ opacity: 'translateY(-100%)' }))
            ])
        ])
    ],
    standalone: false
})
export class DispatchBoardWidgetCalendarComponent implements OnInit {

    private _featureFlagService = inject( FeatureFlagService );

    @Input() filterString: string = '';
    @Input() parentPanel: DispatchBoardPanels;
    @Input() inputData: any = { description: 'Title', value: '000', statusId: '' };
    @Output() openRequest = new EventEmitter<object>();
    @Input() customerFilter: string;
    @Input() set chkOTOntop(bol: boolean) {
        this._chkOTOntop = bol;
        if (CommonFunctions.hasValue(this.data)) {
            const dispatchData = this.data?.dispatchByFilters || [];
            if (this.dispatchBoardPmSubCategorySorting) {
                this.sortDispatchesNew(dispatchData);
            } else {
                this.onToggleChange(false); // Set false to reset toggle logic to avoid issues with old code
                this.sortDispatches(dispatchData);
            }

        }
    }

    @Output() popupLock = new EventEmitter<boolean>();

    public contentTypes = WindowContents;
    protected readonly commonValues = CommonValues;
    subscriptions: Subscription[] = [];
    selectedDispatch: string = '';
    hidePanel: boolean = false;
    _chkOTOntop: boolean = false;
    groupBySubCategoryView: boolean = false;
    searchParam: DispatchBoardSearch;
    sch: DispatchBoardSearch = new DispatchBoardSearch(null);
    data: any = [];
    loadingIndicator: boolean = true;
    showContactFlag: boolean = false;
    dispatches: any;
    public prioritiesFilter: string = ''; //Depricated
    public popupClass: string = 'cp-light-popup';

    public dispatchBoardPmSubCategorySorting: boolean = false;
    dispatchCount: number = 0;

    public priorityFilterState: {
        priorities: Record<string, boolean>;
        subPriorities: Record<string, boolean>;
    } = {
        priorities: {},
        subPriorities: {}
    };


    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService) {
        this.subscriptions.push(svc_data.refreshTrigger$.subscribe(
            refresh => {
                if (this.svc_data.getStatusToRefresh() == this.inputData.statusId) { this.initData(); }

            }));
        this.subscriptions.push(svc_data.selectedDispatch$.subscribe(
            dispatch => {
                this.selectedDispatch = dispatch;
            }));

        this.dispatchBoardPmSubCategorySorting = this._featureFlagService.latestFeatureFlagSet["ui-dispatch-board-pm-sub-category-sorting"];
    }

    ngOnInit() {
        this.loadGroupedPreference();
        this.initData();
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    initData() {
        this.loadingIndicator = true;
        this.dispatches = null;
        this.searchParam = this.sch;
        this.searchParam.userId = this.svc_globals.userId;
        this.searchParam.statusId = this.inputData.statusId;
        this.searchParam.excludeContracts = true;

        if (this.svc_data.hasSearchParams()) {
            this.svc_data.getDispatchesByFilter(this.searchParam, this.dispatchBoardPmSubCategorySorting).subscribe(data => {
                this.data = data;


                if (this.dispatchBoardPmSubCategorySorting) {
                    this.initializeFilters(data.priorityCounts);
                    this.sortDispatchesNew(this.data.dispatchByFilters);
                } else {
                    this.onToggleChange(false); // Set false to reset toggle logic to avoid issues with old code
                    this.sortDispatches(this.data.dispatchByFilters);
                }

                this.loadingIndicator = false;
                this.svc_data.setStatusToRefresh(null);
                if (data.error) {
                    alert('got an error back!');
                }

            });
        }

            else {
                this.data = null;
                this.loadingIndicator = false;
            }

    }

    setPriorityFilter(filter) {
        if (this.dispatchBoardPmSubCategorySorting) {
            this.setPriorityFiltering(filter);
            return;
        } else {
            this.prioritiesFilter = filter;
        }
    }

    dragEnd(e) {
        console.log('dragEnd: ');
    }
    dispatchDragging(e) {
       // this.loadingIndicator = true;
        this.svc_data.setDragParent(DragParent.statusPanelDetail);
        this.svc_data.dispatchDragging(e.dispatch, e.dragState, DragParent.statusPanelDetail);
    }
    sortDispatches(data: any) {
        var dataout: any=[] ;

        if (this._chkOTOntop) {
            var dataOt = data.filter(item => item.priorityName === 'Overtime Approved');
            var dataHigh = data.filter(item => item.priorityName === 'High');
            var dataExtra = data.filter(item => item.priorityName === 'HOT PARTS - ASAP' || item.priorityName === 'Warranty (Hot)');
            var dataRest = data.filter(item => item.priorityName != 'Overtime Approved' && item.priorityName != 'High' && item.priorityName != 'HOT PARTS - ASAP' && item.priorityName != 'Warranty (Hot)');
            dataout = dataout.concat(this.sortDispatchesGrouped(dataOt));
            dataout = dataout.concat(this.sortDispatchesGrouped(dataHigh));
            dataout = dataout.concat(this.sortDispatchesGrouped(dataExtra));
            dataout = dataout.concat(this.sortDispatchesGrouped(dataRest));
           }
        else {
            dataout = this.sortDispatchesGrouped(data);
        }
        this.dispatches = dataout;
    }
    sortDispatchesGrouped(data: any): any {

        if (this.svc_data.dispatchSort) {

            switch (this.svc_data.dispatchSort) {
                case "CreatedPriorityLocation":
                    data.sort(function (a, b) {
                        if (a.receivedDateTime > b.receivedDateTime) { return 1 };
                        if (a.receivedDateTime < b.receivedDateTime) { return -1 };
                        if (a.priorityName > b.priorityName) { return 1 };
                        if (a.priorityName < b.priorityName) { return -1 };
                        if (a.locationName > b.locationName) { return 1 };
                        if (a.locationName < b.locationName) { return -1 };
                    });

                    break;
                case "CustomerLocation":
                    data.sort(function (a, b) {
                        if (a.customerName > b.customerName) { return 1 };
                        if (a.customerName < b.customerName) { return -1 };
                        if (a.locationName > b.locationName) { return 1 };
                        if (a.locationName < b.locationName) { return -1 };
                    });

                    break;

                case "TimeInStatus":
                    data.sort(function (a, b) {
                        if (a.lastStatusChangeDt > b.lastStatusChangeDt) { return 1 };
                        if (a.lastStatusChangeDt < b.lastStatusChangeDt) { return -1 };
                    });

                    break;

                case "Rank":
                    data.sort(function (a, b) {
                        var a1 = a.timeValue;
                        var b1 = b.timeValue;
                        if (!a1) a1 = 99;
                        if (!b1) b1 = 99;
                        if (a1 > b1) { return 1 };
                        if (a1 < b1) { return -1 };
                    });

                    break;

                default:

            }
        }
        return data;
    }

    showContactHover(state: boolean){
        this.showContactFlag = state;
    }
    openWindow(dispatch, trigger) {
        let passedData;
        let windowData;
        switch (trigger) {
            case 1:
                passedData = { data: this.svc_data.statusList, moveDispatch: dispatch };
                windowData = { contentType: this.contentTypes.moveStatus, boardData: passedData };

                this.openRequest.emit(windowData);
                break;
            case 2:
                passedData = { data: this.svc_data.techList, assignDispatch: dispatch };
                windowData = { contentType: this.contentTypes.assignTech, boardData: passedData };

                this.openRequest.emit(windowData);
                break;
            case 3:
                passedData = { data: {}, viewDispatch: dispatch };
                windowData = { contentType: this.contentTypes.viewDispatch, boardData: passedData };

                this.openRequest.emit(windowData);
                break;
            case 4:
                passedData = { data: {}, viewDispatch: dispatch, fullDetail: true };
                windowData = { contentType: this.contentTypes.viewDispatch, boardData: passedData };

                this.openRequest.emit(windowData);
                break;
            case 5:
                passedData = { data: this.svc_data.techList, assignDispatch: dispatch };
                windowData = { contentType: this.contentTypes.unAssignTech, boardData: passedData };

                this.openRequest.emit(windowData);
                break;
        }

    }

    sortDispatchesNew(data: any[]) {
        this.loadingIndicator = true;
        this.dispatches = null;

        const prioritizedData = this.applyPriorityOrdering(data);
        setTimeout(() => {
            if ( this.inputData?.statusId === this.commonValues.Dispatch_PM_All_Customers && this.groupBySubCategoryView ) {
                this.dispatches = this.groupBySubtype( prioritizedData );
            } else {
                this.dispatches = prioritizedData;
            }
            this.loadingIndicator = false;
        }, 0);

    }

    private applyPriorityOrdering(data: any[]): any[] {

        const sortFn = this.getSortFn();

        if (!this._chkOTOntop) {
            return [...data].sort(sortFn);
        }

        const dataOt = data
            .filter(item => item.priorityName === 'Overtime Approved')
            .sort(sortFn);

        const dataHigh = data
            .filter(item => item.priorityName === 'High')
            .sort(sortFn);

        const dataExtra = data
            .filter(item =>
                item.priorityName === 'HOT PARTS - ASAP' ||
                item.priorityName === 'Warranty (Hot)'
            )
            .sort(sortFn);

        const dataRest = data
            .filter(item =>
                item.priorityName !== 'Overtime Approved' &&
                item.priorityName !== 'High' &&
                item.priorityName !== 'HOT PARTS - ASAP' &&
                item.priorityName !== 'Warranty (Hot)'
            )
            .sort(sortFn);

        return [...dataOt, ...dataHigh, ...dataExtra, ...dataRest];
    }

    groupBySubtype(data: any[]) {

        const sortFn = this.getSortFn();

        const grouped = data.reduce((acc, item) => {
            const key = item.prioritySubTypeName || 'Uncategorized';

            if (!acc[key]) {
                acc[key] = [];
            }

            acc[key].push(item);
            return acc;
        }, {} as Record<string, any[]>);

        return Object.keys(grouped)
            .map(key => ({
                subtype: key,
                items: grouped[key].sort(sortFn)
            }))
            .sort((a, b) => {
                const latestA = new Date(a.items[0]?.receivedDateTime || 0).getTime();
                const latestB = new Date(b.items[0]?.receivedDateTime || 0).getTime();

                return latestB - latestA;
            });
    }
    private getSortFn() {
        switch (this.svc_data.dispatchSort) {

            case "CreatedPriorityLocation":
                return (a, b) => {
                    if (a.receivedDateTime > b.receivedDateTime) return 1;
                    if (a.receivedDateTime < b.receivedDateTime) return -1;

                    if (a.priorityName > b.priorityName) return 1;
                    if (a.priorityName < b.priorityName) return -1;

                    if (a.locationName > b.locationName) return 1;
                    if (a.locationName < b.locationName) return -1;

                    return 0;
                };

            case "CustomerLocation":
                return (a, b) => {
                    if (a.customerId > b.customerId) return 1;
                    if (a.customerId < b.customerId) return -1;

                    if (a.locationName > b.locationName) return 1;
                    if (a.locationName < b.locationName) return -1;

                    return 0;
                };

            case "TimeInStatus":
                return (a, b) => {
                    if (a.lastStatusChangeDt > b.lastStatusChangeDt) return 1;
                    if (a.lastStatusChangeDt < b.lastStatusChangeDt) return -1;
                    return 0;
                };

            case "Rank":
                return (a, b) => {
                    let a1 = a.timeValue ?? 99;
                    let b1 = b.timeValue ?? 99;

                    if (a1 > b1) return 1;
                    if (a1 < b1) return -1;
                    return 0;
                };

            default:
                return (a, b) =>
                    new Date(b.receivedDateTime || 0).getTime() -
                    new Date(a.receivedDateTime || 0).getTime();
        }
    }

    private getLocalStorageKey() {
        //TODO Hook into user settings
        return `dispatchBoard-groupBySubCategoryView-${this.inputData?.statusId}`;
    }

    onToggleChange(value: boolean) {
        this.groupBySubCategoryView = value;

        localStorage.setItem(this.getLocalStorageKey(), String(value));

        //this.sortDispatchesNew(this.data?.dispatchByFilters);
        if (this.dispatchBoardPmSubCategorySorting) {
            this.applyFilters();
        } else {
            this.sortDispatchesNew(this.data?.dispatchByFilters || []);
        }
    }

    private loadGroupedPreference() {
        const hasLocalStorageKey = localStorage.getItem(this.getLocalStorageKey());

        if (this.inputData?.statusId !== this.commonValues.Dispatch_PM_All_Customers) {
            this.groupBySubCategoryView = false;
            return;
        }

        if (hasLocalStorageKey !== null) {
            this.groupBySubCategoryView = hasLocalStorageKey === 'true';
        } else {
            this.groupBySubCategoryView = this.inputData?.statusId === this.commonValues.Dispatch_PM_All_Customers;
        }
    }

    //New Priority Handling
    private initializeFilters(priorityCounts: any[]) {
        const priorities: Record<string, boolean> = {};
        const subPriorities: Record<string, boolean> = {};
        (priorityCounts || []).forEach(p => {
            priorities[p.priorityId] = true;

            (p.prioritySubtypeCounts || []).forEach(sp => {
                subPriorities[sp.prioritySubTypeId] = true;
            });
        });

        this.priorityFilterState = { priorities, subPriorities };
    }

    setPriorityFiltering(filter: PriorityFilterState) {
        this.priorityFilterState = filter;
        this.applyFilters();
    }

    private applyFilters() {
        if (!this.data) return;

        const baseData = this.data.dispatchByFilters || [];

        const hasSubPriorityFilters =
            Object.values(this.priorityFilterState.subPriorities).some(v => v === false);

        const filtered = baseData.filter(item => {

            // Priority check
            const priorityAllowed =
                this.priorityFilterState.priorities[item.priorityId] ?? true;

            if (!priorityAllowed) return false;

            // Sub-priority check
            if (item.prioritySubTypeId) {
                if (hasSubPriorityFilters) {
                    return this.priorityFilterState.subPriorities[item.prioritySubTypeId] === true;
                }
                return true;
            }

            return true;
        });

        this.sortDispatchesNew(filtered);
    }


}

